// Letras (fontes) que o painel deixa escolher para os títulos e para os textos do site.
// Também é importado pelo Worker, que injeta a escolha no HTML para a página abrir logo com a letra certa:
// por isso este ficheiro não pode importar nada.

export const FONTS = [
  { key: "ancizar", label: "Ancizar Sans", family: "Ancizar Sans", weights: "400;600;700", serif: false },
  { key: "lato", label: "Lato", family: "Lato", weights: "300;400;700;900", serif: false },
  { key: "montserrat", label: "Montserrat", family: "Montserrat", weights: "400;600;700", serif: false },
  { key: "poppins", label: "Poppins", family: "Poppins", weights: "400;600;700", serif: false },
  { key: "inter", label: "Inter", family: "Inter", weights: "400;600;700", serif: false },
  { key: "dm-sans", label: "DM Sans", family: "DM Sans", weights: "400;600;700", serif: false },
  { key: "manrope", label: "Manrope", family: "Manrope", weights: "400;600;700", serif: false },
  { key: "raleway", label: "Raleway", family: "Raleway", weights: "400;600;700", serif: false },
  { key: "playfair", label: "Playfair Display (serifada)", family: "Playfair Display", weights: "400;600;700", serif: true },
  { key: "cormorant", label: "Cormorant Garamond (serifada)", family: "Cormorant Garamond", weights: "400;600;700", serif: true },
];

export const DEFAULT_FONTS = { font_title: "ancizar", font_body: "lato" };

const BY_KEY = Object.fromEntries(FONTS.map((font) => [font.key, font]));

// Letra escolhida no painel; uma chave desconhecida ou vazia volta à da marca
export function chosenFont(content, field) {
  return BY_KEY[content?.[field]] || BY_KEY[DEFAULT_FONTS[field]];
}

const stack = (font) =>
  `'${font.family}', ${font.serif ? "Georgia, 'Times New Roman', serif" : "'Segoe UI', system-ui, sans-serif"}`;

// Variáveis CSS que o site usa (--font-title nos títulos, --font-body no resto)
export function fontVars(content) {
  return {
    "--font-title": stack(chosenFont(content, "font_title")),
    "--font-body": stack(chosenFont(content, "font_body")),
  };
}

// Endereço do Google Fonts que carrega as letras indicadas (sem repetidos)
export function fontsHref(fonts) {
  const unique = [...new Map(fonts.map((font) => [font.key, font])).values()];
  const families = unique.map((font) => `family=${font.family.replace(/ /g, "+")}:wght@${font.weights}`);
  return `https://fonts.googleapis.com/css2?${families.join("&")}&display=swap`;
}

export const chosenFontsHref = (content) =>
  fontsHref([chosenFont(content, "font_title"), chosenFont(content, "font_body")]);

export const isDefaultFonts = (content) =>
  chosenFont(content, "font_title").key === DEFAULT_FONTS.font_title &&
  chosenFont(content, "font_body").key === DEFAULT_FONTS.font_body;
